export const FINPSP_BANK_TYPE = {
  BKASH: 'Bkash',
  NAGAD: 'Nagad',
  UPAY: 'Upay',
  ROCKET: 'Rocket',
} as const;

export const FINPSP_METHOD_LABELS = {
  [FINPSP_BANK_TYPE.BKASH]: 'bKash',
  [FINPSP_BANK_TYPE.NAGAD]: 'Nagad',
  [FINPSP_BANK_TYPE.UPAY]: 'Upay',
  [FINPSP_BANK_TYPE.ROCKET]: 'Rocket',
} as const;

export const FINPSP_STATE = {
  CREATED: 'created',
  AWAITING_APPROVAL: 'awaiting_approval',
  SUBMITTING: 'submitting',
  PENDING: 'pending',
  SUBMISSION_UNKNOWN: 'submission_unknown',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  REVIEW: 'review',
} as const;

export type FinpspState = (typeof FINPSP_STATE)[keyof typeof FINPSP_STATE];

export const FINPSP_STATE_LABELS: Record<FinpspState, string> = {
  [FINPSP_STATE.CREATED]: 'Created',
  [FINPSP_STATE.AWAITING_APPROVAL]: 'Awaiting platform approval',
  [FINPSP_STATE.SUBMITTING]: 'Submitting to FINPSP',
  [FINPSP_STATE.PENDING]: 'Pending provider confirmation',
  [FINPSP_STATE.SUBMISSION_UNKNOWN]: 'Submission outcome unknown',
  [FINPSP_STATE.APPROVED]: 'Completed',
  [FINPSP_STATE.REJECTED]: 'Rejected',
  [FINPSP_STATE.REVIEW]: 'Needs reconciliation',
};

export const FINPSP_CURRENCY = 'BDT';
